import { isObject, isArray, isBoolean } from 'utils/typeUtils';
import { isNumber } from '../utils/typeUtils';

/**
 * メニューに紐づくクローラー
 */
export type MenuCrawler = {
  /** メニューID */
  menuId: number;
  /** クローラーID */
  crawlerId: number;
  /** 先頭のクローラーか否か */
  firstCrawler: boolean;
  /** このクローラーの後続処理になれるクローラー */
  targetCrawlers: number[] | null;
  /** 表示順 */
  displayOrder: number;
};

/**
 * メニューに紐づくクローラーの型ガード
 */
export const isMenuCrawler = (arg: unknown): arg is MenuCrawler => {
  const a = arg as MenuCrawler;

  return (
    isObject(a) &&
    isNumber(a.menuId) &&
    isNumber(a.crawlerId) &&
    isBoolean(a.firstCrawler) &&
    (isArray(a.targetCrawlers, isNumber) || a.targetCrawlers === null) &&
    isNumber(a.displayOrder)
  );
};

/**
 * メニューに紐づくクローラーの配列の型ガード
 */
export const isMenuCrawlers = (arg: unknown): arg is MenuCrawler[] => {
  const a = arg as MenuCrawler[];

  return isObject(a) && isArray<MenuCrawler>(a, isMenuCrawler);
};
